module.exports = __webpack_public_path__ + "img/宣传_152.14e15c8e.jpg";